import React from 'react'
import { ButtonBlock } from '@core/Components/Buttons/ButtonBlock'
import { BettingDrawerBase } from './Components/BettingDrawerBase'

export const BettingDrawer: React.FC<
  {
    open: boolean
    handleQuickbetClick(): void
    handleAddToBetslipClick?(): void
    dataTId?: string
  } & Pick<
    React.ComponentProps<typeof BettingDrawerBase>,
    'forcedZIndex' | 'shouldDisplayAboveTabNav'
  >
> = ({
  open,
  handleQuickbetClick,
  handleAddToBetslipClick,
  dataTId = 'forward-buttons',
  shouldDisplayAboveTabNav = false,
  forcedZIndex,
}) => (
  <BettingDrawerBase
    isOpen={open}
    testId='betting-drawer'
    shouldDisplayAboveTabNav={shouldDisplayAboveTabNav}
    forcedZIndex={forcedZIndex}
    secondaryButtonSlot={
      handleAddToBetslipClick && (
        <ButtonBlock
          onClick={handleAddToBetslipClick}
          data-tid-add-to-betslip={`bet-${dataTId}`}
          color='secondary'
        >
          Add to Bet Slip
        </ButtonBlock>
      )
    }
    primaryButtonSlot={
      <ButtonBlock onClick={handleQuickbetClick} data-tid-place-single-btn={`bet-${dataTId}`}>
        Quickbet
      </ButtonBlock>
    }
  />
)
